import { Navigate, Outlet, useLocation } from 'react-router';
import { Splash } from '@/components/Splash';
import { session } from '@/lib/storage';
import { useAuth } from './context';

/** Where to land right after signing in/up (sign-up goes to onboarding). */
export const AFTER_AUTH_KEY = 'mydash.after-auth';

/** Routes that need a session. Sends anonymous users to sign-in with a `next` back here. */
export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <Splash />;
  if (status === 'anonymous') {
    const next = location.pathname + location.search;
    return <Navigate to={`/sign-in${next !== '/' ? `?next=${encodeURIComponent(next)}` : ''}`} replace />;
  }
  return <Outlet />;
}

/** Sign-in, sign-up and forgot-password: signed-in users go to the app. */
export function PublicOnly() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <Splash />;
  if (status === 'authenticated') {
    const after = session.get<string | null>(AFTER_AUTH_KEY, null);
    if (after) session.remove(AFTER_AUTH_KEY);
    const next = after ?? new URLSearchParams(location.search).get('next');
    return <Navigate to={next && next.startsWith('/') && !next.startsWith('//') ? next : '/'} replace />;
  }
  return <Outlet />;
}
